// Native v4 MaintenanceOverlay — port of
// src/components/common/overlay/MaintenanceOverlay.tsx: the banned-mode env
// math is verbatim; when banned it replaces the whole app with a maintenance
// card (v3 hardcoded English → i18n'd, MaintenanceOverlay.* keys).
import React from 'react';
import { useTranslation } from 'react-i18next';

import { APStatusView } from '@/components/ap/status/APStatusView';
import { AppConfig } from '@/config/appConfig';
import { SettingsLinear } from '@assessprep/icons/solar';

export const MaintenanceOverlay = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const isBannedMode =
    import.meta.env.VITE_MAINTENANCE_MODE === 'true' ||
    (AppConfig.mode === 'production' && AppConfig.webUrl?.includes('localhost')) ||
    (AppConfig.mode === 'development' && AppConfig.apiUrl?.includes('api.assessprep.com'));

  if (!isBannedMode) {
    return <>{children}</>;
  }

  const startTime = import.meta.env.VITE_MAINTENANCE_MODE_START_TIME;
  const endTime = import.meta.env.VITE_MAINTENANCE_MODE_END_TIME;

  return (
    <APStatusView
      fullScreen
      tone="neutral"
      icon={<SettingsLinear className="animate-spin" />}
      title={t('MaintenanceOverlay.well_be_back_soon')}
      testId="v4-maintenance-overlay"
      description={
        <span className="flex flex-col gap-1">
          <span>{t('MaintenanceOverlay.assessprep_is_undergoing_routine_maintenance')}</span>
          <span>{t('MaintenanceOverlay.from_start_to_end', { startTime, endTime })}</span>
          <span className="mt-4">{t('MaintenanceOverlay.email_support_assessprep_com')}</span>
        </span>
      }
    />
  );
};
